import type { AITaskType, AIUseCase, BusinessProfile, ReadinessScore, RiskAssessment, RoleCheckRecord, TransparencyCheck } from "./types";

export const taskTypes: AITaskType[] = [
  "use_case_summary", "use_case_policy_clause", "use_case_customer_notice", "use_case_dossier_section",
  "tool_rule_text", "tool_dossier_section", "tool_action_hint",
  "role_check_summary", "role_check_action_explanation", "role_check_dossier_section",
  "risk_summary", "risk_action_prioritization", "risk_dossier_section",
  "literacy_dossier_text", "literacy_basic_rules", "literacy_short_briefing",
  "transparency_website_notice", "transparency_offer_notice", "transparency_customer_project_notice", "transparency_content_notice", "transparency_chatbot_notice", "transparency_dossier_section",
  "document_executive_summary", "document_policy_text", "document_customer_notice", "document_action_plan_summary", "document_one_page_summary",
  "dashboard_readiness_summary", "dashboard_next_steps", "dashboard_recheck_notice"
];

export interface PrivacyPayload {
  business_segment?: string;
  service_areas?: string[];
  use_case_category?: string;
  tool_category?: string;
  data_categories?: string[];
  output_type?: string;
  human_review?: string;
  risk_distribution?: Record<string, number>;
  role_profile?: string;
  transparency_status?: string;
  readiness_score?: number;
  red_points_count?: number;
}

export function blockedFields() {
  return [
    "Name", "Firmenname", "Kundennamen", "E-Mail-Adressen", "Telefonnummern", "URLs",
    "konkrete Toolnamen", "Freitexte", "Use-Case-Beschreibungen", "Notizen",
    "Dokumenteninhalte", "Transkripte", "vollständige lokale Datenbank", "JSON Backups"
  ];
}

export function buildPrivacyPayload(input: {
  task_type: AITaskType;
  profile?: BusinessProfile;
  useCase?: AIUseCase;
  risks?: RiskAssessment[];
  role?: RoleCheckRecord;
  transparency?: TransparencyCheck;
  score?: ReadinessScore;
}): { payload: PrivacyPayload; sentFields: string[]; blockedFields: string[] } {
  const distribution = (input.risks ?? []).reduce<Record<string, number>>((acc, item) => {
    acc[item.traffic_light] = (acc[item.traffic_light] ?? 0) + 1;
    return acc;
  }, {});
  const payload: PrivacyPayload = {
    business_segment: input.profile?.business_segment,
    service_areas: input.profile?.service_areas,
    use_case_category: input.useCase?.category,
    tool_category: input.useCase?.tool_category,
    data_categories: input.useCase?.data_categories,
    output_type: input.useCase?.output_type,
    human_review: input.useCase?.human_review,
    risk_distribution: Object.keys(distribution).length ? distribution : undefined,
    role_profile: input.role?.profile,
    transparency_status: input.transparency?.status,
    readiness_score: input.score?.score,
    red_points_count: input.score?.red_points_count
  };
  const compact = Object.fromEntries(Object.entries(payload).filter(([, value]) => value !== undefined)) as PrivacyPayload;
  return { payload: compact, sentFields: Object.keys(compact), blockedFields: blockedFields() };
}

export function assertAllowedTaskType(taskType: string): asserts taskType is AITaskType {
  if (!taskTypes.includes(taskType as AITaskType)) {
    throw new Error("Task Type ist nicht in der zentralen AI-Orchestration-Registry erlaubt.");
  }
}
